'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _richMediaConnectDecorator = require('../richMediaConnectDecorator');

var _richMediaConnectDecorator2 = _interopRequireDefault(_richMediaConnectDecorator);

var _RichMediaPreviewImage = require('./RichMediaPreviewImage');

var _RichMediaPreviewImage2 = _interopRequireDefault(_RichMediaPreviewImage);

var _RichMediaContent = require('./RichMediaContent');

var _RichMediaContent2 = _interopRequireDefault(_RichMediaContent);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // Lib


// Components


var RichMedia = function (_React$Component) {
    _inherits(RichMedia, _React$Component);

    function RichMedia() {
        var _ref;

        var _temp, _this, _ret;

        _classCallCheck(this, RichMedia);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = RichMedia.__proto__ || Object.getPrototypeOf(RichMedia)).call.apply(_ref, [this].concat(args))), _this), _this.onPreviewClick = function (event) {
            event.stopPropagation();
            _this.props.dispatchRichMediaEmbedding();
        }, _temp), _possibleConstructorReturn(_this, _ret);
    }

    _createClass(RichMedia, [{
        key: 'render',
        value: function render() {
            var _props = this.props,
                element = _props.element,
                className = _props.className,
                showPreview = _props.showPreview,
                showRichMedia = _props.showRichMedia,
                embeddingRichMedia = _props.embeddingRichMedia,
                _props$ContentCompone = _props.ContentComponent,
                ContentComponent = _props$ContentCompone === undefined ? _RichMediaContent2.default : _props$ContentCompone,
                _props$PreviewCompone = _props.PreviewComponent,
                PreviewComponent = _props$PreviewCompone === undefined ? _RichMediaPreviewImage2.default : _props$PreviewCompone;


            var mediaData = element.getIn(['content', 'media']);
            var imageData = element.getIn(['content', 'image']);

            return _react2.default.createElement(
                'div',
                { className: (0, _classnames2.default)('RichMedia', className) },
                _react2.default.createElement(ContentComponent, _extends({}, this.props, { show: showRichMedia, mediaData: mediaData })),
                _react2.default.createElement(PreviewComponent, _extends({}, this.props, { show: showPreview, showLoader: embeddingRichMedia,
                    mediaData: mediaData,
                    imageData: imageData,
                    onClick: this.onPreviewClick }))
            );
        }
    }]);

    return RichMedia;
}(_react2.default.Component);

RichMedia.propTypes = {
    element: _propTypes2.default.object.isRequired,
    PreviewComponent: _propTypes2.default.func,
    ContentComponent: _propTypes2.default.func,
    showPreview: _propTypes2.default.bool,
    embeddingRichMedia: _propTypes2.default.bool,
    showRichMedia: _propTypes2.default.bool,
    dispatchRichMediaEmbedding: _propTypes2.default.func,
    className: _propTypes2.default.string
};

exports.default = (0, _richMediaConnectDecorator2.default)(RichMedia);


//////////////////
// WEBPACK FOOTER
// ./src/client/element/richMedia/components/RichMedia.js
// module id = 457
// module chunks = 0